import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getChildOuData = createAsyncThunk('OuSlice/getChildOuData', async (value) => {
  value.isDescending = value.isDescending ? value.isDescending : false;
  value.sortType = value.sortType ? value.sortType : '';
  const response = await axios.get(
    `GetADDetails/getChildOU?OU=${value.ouName}&FQDN=${value.fqdn}&search=${value.searchQuery}&page=${value.page}&pageSize=${value.pageSize}&isDescending=${value.isDescending}&sortType=${value.sortType}`
  );

  return response.data;
});
//getSingleOu
export const getOneOu = createAsyncThunk('OuSlice/getOneOu', async (value) => {
  const response = await axios.get(`GetADDetails/getSingleOU?OU=${value.ou}&FQDN=${value.fqdn}`);
  return { data: response.data, status: response.status };
});
export const getExportOus = createAsyncThunk('OuSlice/getExportOus', async (value) => {
  const response = await axios.get(
    `GetADDetails/exportou?OU=${value.ouName}&FQDN=${value.fqdn}&search=${value.searchQuery}`
  );

  return response.data;
});
//fetch child ouData for Dropdown
export const getChildOuDropdown = createAsyncThunk('childOuTreeData/dropdown', async (value) => {
  const response = await axios.get(`GetADDetails/getChildOU?OU=${value.ouName}&FQDN=${value.fqdn}`);
  return response.data;
});
//fetch containers values
export const getDomainContainers = createAsyncThunk('getDomainContainers/Containers', async (value) => {
  const response = await axios.get(`GetADDetails/getDomainContainers?FQDN=${value}`);
  return response.data;
});
//createChildou
export const createChildOuData = createAsyncThunk('OuSlice/CreateChildOU', async (values) => {
  try {
    const response = await axios.post(`GetADDetails/CreateChildOU`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
//CreateParentOu
export const createParentOuData = createAsyncThunk('OuSlice/createParentOuData', async (values) => {
  try {
    const response = await axios.post(`GetADDetails/CreateParentOU`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});

export const updateOuDataProperties = createAsyncThunk('OuSlice/updateOuDataProperties', async (values) => {
  try {
    const response = await axios.put(`GetADDetails/UpdateOUProperties`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
export const deleteOuData = createAsyncThunk('OuSlice/deleteOuData', async (value) => {
  try {
    const response = await axios.delete(`GetADDetails/DeleteOU?Dn=${value.ou}&FQDN=${value.fqdn}`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});

const initialState = {
  data: [],
  loading: false,
  error: null,
  totalCount: 0,
  totalPages: 0,
  pageOuNumber: 1,
  pageOuSize: 20,
  ouSearch: '',
  childOuDropdown: [],
  domainContainers: [],
  ouIsDescending: false,
  ouSortType: '',
};

const getChlidOu = createSlice({
  name: 'getChildOuData',
  initialState,
  reducers: {
    setPageOuNumber: (state, action) => {
      state.pageOuNumber = action.payload;
    },
    setPageOuSize: (state, action) => {
      state.pageOuSize = action.payload;
    },
    setOuSearch: (state, action) => {
      state.ouSearch = action.payload;
    },
    setOuIsDescending: (state, action) => {
      state.ouIsDescending = action.payload;
    },
    setOuSortType: (state, action) => {
      state.ouSortType = action.payload;
    },
    resetOus: (state) => {
      state.pageOuNumber = 1;
      state.pageOuSize = 20;
      state.ouSearch = '';
      state.ouIsDescending = false;
      state.ouSortType = '';
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(getChildOuData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChildOuData.fulfilled, (state, action) => {
        state.loading = false;
        state.sortOuLoader = false;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.data = action.payload.ouList;
      })
      .addCase(getChildOuData.rejected, (state, action) => {
        state.loading = false;
        state.sortOuLoader = false;
        state.error = action.payload;
      })
      .addCase(getChildOuDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.childOuDropdown = action.payload.ouList;
      })
      .addCase(getDomainContainers.fulfilled, (state, action) => {
        state.loading = false;
        state.domainContainers = action.payload;
      });
  },
});

export const {
  addChildToTree,
  setPageOuSize,
  setOuSearch,
  setPageOuNumber,
  setOuIsDescending,
  setOuSortType,
  resetOus,
} = getChlidOu.actions;

export default getChlidOu.reducer;
